module.exports = __webpack_public_path__ + "static/media/product-details-graph.a8ddf9b9.png";